import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { Environment } from 'src/environments/environment.model';

import { CropVariety } from '../models';

@Injectable({
  providedIn: 'root',
})
export class CropVarietyService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private baseUrl = `${this.env.APIM_BASE_URL}/arable-service/cropvariety`;
  private arableAdviceBaseUrl = `${this.env.APIM_BASE_URL}/arable-advice-service/crop-fields`;

  getCropVarietiesByCropId(cropId: number): Observable<CropVariety[]> {
    return this.http.get<CropVariety[]>(`${this.baseUrl}/cropId/${cropId}`);
  }

  getCropVarietiesByCropIds(cropIds: number[]): Observable<CropVariety[]> {
    const uniqueCropIds = [...cropIds]
      .sort()
      .filter((item, pos, ary) => !pos || item !== ary[pos - 1]);
    return this.http.get<CropVariety[]>(
      `${this.baseUrl}/cropids?${this.getParamString('cropIds', uniqueCropIds)}`,
    );
  }

  getAvailableBemCropVarieties(cropFieldId: number): Observable<CropVariety[]> {
    return this.http.get<CropVariety[]>(
      `${this.arableAdviceBaseUrl}/${cropFieldId}/available-crop-varieties`,
    );
  }

  private getParamString(key: string, values: number[] | string[]): string {
    return values.map((value) => `${key}=${value}`).join('&');
  }
}
